import { createFileRoute } from "@tanstack/react-router";
import SeriesDetailsSkeleton from "@/modules/SeriesDetails/SeriesDetailsSkeleton";
import { redirectSeriesDeeplink } from "@/lib/seriesDeeplink";

// Mobile deeplink `/series-details?id={id}` (SHO-675): opens the series
// details page (SHO-757), where `/series-player` opens the player.
export const Route = createFileRoute("/_videoPlayer/series-details")({
  loader: ({ location }) =>
    redirectSeriesDeeplink(location.search, { target: "series" }),
  pendingMs: 0,
  pendingMinMs: 0,
  pendingComponent: PendingSeriesDetails,
});

// Under `_videoPlayer` there is no header, while the page it redirects to
// sits under `_default`'s `mt-26`: the same offset here, or the skeleton
// paints at the top and the page then drops below the header.
function PendingSeriesDetails() {
  return (
    <div className="mt-26">
      <SeriesDetailsSkeleton />
    </div>
  );
}
